export default "<ion-app>\n  <ion-content class=\"fondopur\">\n    <ion-router-outlet ></ion-router-outlet>\n  </ion-content>\n</ion-app>\n\n";